import { ApiError } from '@eneco/dc/client/ApiError';

/**
 * The error vocabulary between the getOffer actor and the machine. xstate surfaces a rejected actor
 * as `event.error`, so the message is the only channel the actor has to say what went wrong, and
 * the machine's `onError` guards match on exactly these values.
 */
export const OfferErrorMessage = {
  NotFound: 'Not Found',
  SalesCapReached: 'Sales Cap Reached',
  Unauthorized: 'Unauthorized',
} as const;

/** The API returns this guid in a Bad Request when the sales cap for the offer has been reached. */
const SALES_CAP_ERROR_CODE = 'f8bdd982-6924-4daf-906c-ea976beff26c';

/**
 * Translates a failed offer request into the vocabulary above. Anything that is not an `ApiError`
 * is passed through untouched — it is a programming error, not an API outcome, and hiding it behind
 * an offer-specific message would lose the stack.
 */
export const toOfferError = (error: unknown): unknown => {
  if (!(error instanceof ApiError)) {
    return error;
  }

  if (error.message === 'Bad Request' && error.firstError?.code?.includes(SALES_CAP_ERROR_CODE)) {
    return new Error(OfferErrorMessage.SalesCapReached);
  }

  return new Error(error.message);
};
